exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*******************************\nReset (Admin/UI)\n*******************************/\nbody,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 300;\n}\n/* Border-Box */\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\nhtml {\n  box-sizing: border-box;\n}\n/* iPad Input Shadows */\ninput[type='text'],\ninput[type='email'],\ninput[type='search'],\ninput[type='password'] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  /* mobile firefox too! */\n}\n", ""]);

// exports
